<template>
	<span class="candidate-counter" :class="{ active: leftSidebar == 'compares', 'opacity-0': candidates.length == 0 }">{{ candidates.length }}</span>
</template>

<script>
import { mapState } from "vuex";

export default {
	computed: {
		...mapState("UI", ["candidates", "leftSidebar"]),
	},
};
</script>

<style lang="scss" scoped>
.candidate-counter {
    font-size: 0.7rem;
    line-height: 1;
    font-weight: bold;
    min-width: 18px;
    text-align: center;
    background: var(--primary);
    border-radius: 5px;
    color: white;
    padding: 2px 7px;
    margin-left: 0;
    //position: absolute;
    //left: 0;
    //transform: translateX(-125%);
}
</style>
